import { useContext } from 'react';

import { messages } from '../i18n';
import { IntlContext } from '../providers/IntlProvider';

export const useIntl = () => {
  const { locale } = useContext(IntlContext);

  const formatMessage = ({ id }: { id: string }, values?: Record<string, string | number>) => {
    let message = messages[locale][id] || id;

    if (values) {
      Object.entries(values).forEach(([key, value]) => {
        message = message.replace(`{${key}}`, String(value));
      });
    }

    return message;
  };

  return {
    locale,
    formatMessage,
  };
};
